<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Пользователи
                </div>
                <div class="ap-workspace-label-btn" v-on:click="createNewUser">
                    <SVGPlus/>
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти пользователя" v-model="mask">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <table class="result-table">
                    <thead>
                    <tr class="head-tr">
                        <th>№</th>
                        <th>Имя</th>
                        <th>E-mail</th>
                        <th>Телефон</th>
                        <th>Роль</th>
                        <th>Зарегистрирован</th>
                        <th class="field-edit">Опции</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="body-tr row" v-for="(value, index) in users">
<!--                        <td>-->
<!--                            <span class="table-data-central">{{value.id}}</span>-->
<!--                        </td>-->
                        <td>
                            <span class="table-data">{{index+1}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.fullname}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.email}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.phone}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{value.role}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{dateIntoRu(value.create_date)}}</span>
                        </td>
                        <td>
                            <div class="edit-button-group">
                                <div class="table-svg-button" v-on:click="editRow(value)">
                                    <SVGAdminEditRow/>
                                </div>
                                <div class="table-svg-button" v-on:click="confirm(value)">
                                    <SVGAdminDeleteRow/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="waitingResponseToUsersRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка пользователей ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    import AddUser from "../../Modal/AdminPage/PageUsers/AddUser";
    import ChangeUser from "../../Modal/AdminPage/PageUsers/ChangeUser";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalConfirmation from "../../Modal/ModalConfirmation";

    export default {
        name: "AdminUsers",
        mixins: [urlForStaticVue],
        components: {
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        data(){
            return {
                timerId: null
            }
        },
        computed: {
            mask:{
                get() {
                    return this.$store.state.adminPanel.users.mask;
                },
                set(value) {
                    this.$store.commit('adminPanel/users/MASK', value);
                    if (this.timerId) {
                        clearTimeout(this.timerId);
                        this.timerId = null;
                    }
                    this.timerId = setTimeout(() => {
                        this.$store.commit('adminPanel/users/CLEAR_USERS');
                        this.$store.dispatch('adminPanel/users/GET_USERS');
                        this.timerId = null;
                    }, 500);
                }
            },
            users() {
                return this.$store.getters["adminPanel/users/SELF"];
            },
            waitingResponseToUsersRequest(){
                return this.$store.state.adminPanel.users.waitingResponseToUserRequest;
            }
        },
        methods: {
            dateIntoRu(createDate) {
                let date = new Date(createDate).toLocaleString('ru', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return date;
            },
            scrollReachEnd() {
                this.$store.dispatch('adminPanel/users/GET_USERS');
            },
            createNewUser() {
                this.$modal.show(AddUser, {}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 480,
                    draggable: true,
                });
            },
            editRow(userData) {
                this.$modal.show(ChangeUser, {userData}, {
                    height: 'auto',
                    pivotY: 0.2,
                    width: 480,
                    draggable: true,
                });
            },
            deleteRow(userID) {
                return () => {this.$store.dispatch('adminPanel/users/DELETE_USER', userID)};
            },
            confirm(user) {
                const title = `Удалить пользователя "${user.fullname}"?`
                const text = 'Запись о данном пользователе будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(user.id)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
        },
        async mounted() {
            await this.$store.dispatch('adminPanel/users/GET_USERS');
        }
    }
</script>

<style scoped>

</style>
